const STORAGE_KEY = "dblog_local_auth";
const AUTH_EVENT = "dblog-local-auth";

export const LOCAL_DEV_EMAIL =
  process.env.REACT_APP_LOCAL_USER_EMAIL || "local@dblogcss.com";
export const LOCAL_DEV_PASSWORD =
  process.env.REACT_APP_LOCAL_USER_PASSWORD || "localdev";
export const LOCAL_DEV_NAME =
  process.env.REACT_APP_LOCAL_USER_NAME || "Local User";

/** Dev-only local login. Production builds set NODE_ENV=production, so this is off. */
export function isLocalAuthEnabled() {
  return process.env.NODE_ENV === "development";
}

export function getLocalUser() {
  if (!isLocalAuthEnabled()) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.email) return null;
    const displayName = String(parsed.displayName || "").trim();
    return {
      email: parsed.email,
      ...(displayName ? { displayName } : {}),
      isLocal: true,
    };
  } catch {
    return null;
  }
}

export function signInLocal(email, password) {
  if (!isLocalAuthEnabled()) return false;

  const emailOk =
    String(email || "").trim().toLowerCase() === LOCAL_DEV_EMAIL.toLowerCase();
  const passwordOk = String(password || "") === LOCAL_DEV_PASSWORD;
  if (!emailOk || !passwordOk) return false;

  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      email: LOCAL_DEV_EMAIL,
      displayName: LOCAL_DEV_NAME,
      isLocal: true,
    })
  );
  window.dispatchEvent(new Event(AUTH_EVENT));
  return true;
}

/** One-click local session for development (no form required). */
export function signInLocalDemo() {
  if (!isLocalAuthEnabled()) return false;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      email: LOCAL_DEV_EMAIL,
      displayName: LOCAL_DEV_NAME,
      isLocal: true,
    })
  );
  window.dispatchEvent(new Event(AUTH_EVENT));
  return true;
}

export function signOutLocal() {
  sessionStorage.removeItem(STORAGE_KEY);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(AUTH_EVENT));
  }
}

export function subscribeLocalAuth(listener) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(AUTH_EVENT, listener);
  return () => window.removeEventListener(AUTH_EVENT, listener);
}
